import { getModelFrontLogs, getModelFrontLogById } from '../../thunk/modelFrontLogs';

export default (builder) => {
    builder
        .addCase(getModelFrontLogs.pending, (state) => {
            state.status = 'loading';
            state.error = null;
        })
        .addCase(getModelFrontLogs.fulfilled, (state, action) => {
            state.status = 'succeeded';
            state.data = action.payload;
            state.error = null;
            if (action.payload) {
                state.queryParams = {
                    ...state.queryParams,
                    page: action.payload.page || state.queryParams.page || 1,
                    limit: action.payload.perPage || state.queryParams.limit || 50,
                };
            }
        })
        .addCase(getModelFrontLogs.rejected, (state, action) => {
            state.status = 'failed';
            state.error = action.payload;
        })
        .addCase(getModelFrontLogById.pending, (state) => {
            state.singleLogStatus = 'loading';
            state.singleLogError = null;
        })
        .addCase(getModelFrontLogById.fulfilled, (state, action) => {
            state.singleLogStatus = 'succeeded';
            state.singleLog = action.payload;
            state.singleLogError = null;
        })
        .addCase(getModelFrontLogById.rejected, (state, action) => {
            state.singleLogStatus = 'failed';
            state.singleLogError = action.payload;
        });
};
